import { useState } from "react";
import { AllStats } from "../api/dashboard";
import { useToast } from "../components/Toast";

const useDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);
  const { addToast } = useToast();

  const getAllStats = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const data = await AllStats(token);
      setStats(data);
      return data;
    } catch (error) {
      addToast(error?.response?.data?.detail || "Failed to fetch stats", {
        appearance: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return { loading, stats, getAllStats };
};

export default useDashboard;
